const Dg_AreaCode = '125e8739-531a-4cfa-bba8-71fa0fffb0f3'
const Nmg_MW='37a00d8e-1e5f-48ca-98a0-200eee4d3bd5_8ee62609-cd24-4d0e-b4b4-477de8766d05_ee524d58-f3f1-4d1d-929f-f067fd58112b_4a3a0e4f-ef5d-492e-969e-c2edb8216650'
export default{
    Dg_AreaCode,
    Nmg_MW
}
